module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-800.35386154.woff2";